<template>
  <div class="terms-of-use">
    <HeaderComponent screenName="" />
    <ContractVehiclesBannerComponent
      imageSrc="contracts-banner.jpg"
      heading="Terms of Use"
    />
    <div class="section-div" data-aos="fade-up">
     <div class="cards-container">   
      <div class="card" data-aos="fade-up">
        <p>
        Welcome to the G14C web site (the “Site”). By accessing the Site and going through its contents, it is implied that you have read, understood, agreed to and accepted the following terms and conditions on the usage of the website. If you do not agree to these terms, do not use the Site.<br><br>

        The Site is the sole property of G14C. The Site may contain other proprietary notices and copyright information, the terms of which must be observed and followed. Information on the Site may contain technical inaccuracies or typographical errors.<br><br>

        G14C may revise the terms of use from time to time without notice.<br><br>

        G14C may also make improvements and/or changes in the services and/or the solutions described in the Site at any time without notice. The Site may provide links to other web sites and access to content, products and services from third parties including users, advertisers, and affiliates. G14C is not responsible for the content provided on third party web sites.<br><br>

        The use of content from the Site, including uploading, downloading, modification, publication, transmission, participation in the transfer or sale of, copying, reproduction, republishing, creation of derivative works from, distribution, performance, display, incorporation into another web site, reproduction (whether by linking, framing or any other method), or exploiting the content, in whole or in part, cannot be made without G14C's prior written consent.<br><br>

        All materials and information, content, software, products and services given in this site are provided on an "as is" and "as available" basis.<br><br>

        While G14C uses reasonable efforts to include accurate and up-to-date information in the Site, G14C does not make any warranties, express or implied, including, without limitation, those of merchantability and fitness for a particular purpose, with respect to any information or products made available in the web site.<br><br>

        G14C's obligations with respect to its products and services are governed solely by the agreements under which they are provided.<br><br>

        G14C provides no assurances that any reported problems may be resolved with the use of any information that G14C provides.<br><br>
        </p>
        
      </div>
    </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    FooterComponent,
  },
});
</script>

<style scoped>
.section-div {
  background-color: #f2f2f2;
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 100px;
  padding-bottom: 50px;
}

.cards-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 55px; 
}

.card {
  background-color: #fff;
  padding: 50px;
  width: 85%; 
  height: auto;
  text-align: left;
  font-family: Roboto;
  box-shadow:  0 8px 16px rgba(0, 0, 0, 0.2); 
  font-size: 20px; 
}
</style>
